import React from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { Card, Typography, Avatar, Badge, Button, Space, Descriptions } from 'antd';
import * as Icon from 'react-feather';

import { useQuery } from 'react-query';
import { get_valuer_panel } from 'services/apiSrv';

const { Title, Text } = Typography;

export default function ViewValuer() {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();

  // Support navigation state: when navigating from the panel we pass the full valuer object
  const navValuer = location?.state?.valuer;

  const {
    data: valuers = [],
    isLoading: isValuers,
    error: subvaluerError,
  } = useQuery({
    queryKey: ['valuer_panel'],
    queryFn:get_valuer_panel,
  });
  const valuer = navValuer || valuers?.data?.panel?.find((v) => v.valuerInternalRef === id)

  const getStatusColor = (status) => {
    const map = {
      active: '#52c41a',
      pending: '#faad14',
      inactive: '#ff4d4f',
    };
    return map[status?.toLowerCase()] || '#1890ff';
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: 24 }}>
      {!valuer ? (
        <Card style={{ borderRadius: 12 }}>
          <div style={{ padding: 24 }}>
            <Text type="secondary">No valuer found for id:</Text>
            <Title level={4} style={{ marginTop: 8 }}>{id}</Title>
            <div style={{ marginTop: 12 }}>
              <Button onClick={() => history.goBack()}>Back</Button>
            </div>
          </div>
        </Card>
      ) : (
        <>
          <Card
            style={{ marginBottom: 24, borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: 'none' }}
            title={
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <Text type="secondary" style={{ fontSize: 14, display: 'block' }}>Valuer</Text>
                  <Title level={3} style={{ margin: 0, color: '#1890ff', fontWeight: 600 }}>{valuer.name}</Title>
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                  <Badge color={getStatusColor('active')} text={<Text strong>ACTIVE</Text>} />
                  <Space>
                    <Button type="primary" icon={<Icon.Edit size={14} />} onClick={() => alert('Edit not implemented')}>Edit</Button>
                    <Button onClick={() => history.goBack()} icon={<Icon.ArrowLeft size={14} />}>Back</Button>
                  </Space>
                </div>
              </div>
            }
          >
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
              <div style={{ display: 'flex', gap: 16, alignItems: 'center', flex: 1 }}>
                <Avatar size={96} src={valuer.imagePath || undefined} style={{ backgroundColor: '#e6f7ff', color: '#001529' }}>
                  {valuer.name ? valuer.name.split(' ').map(n=>n[0]).slice(0,2).join('') : ''}
                </Avatar>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 700 }}>{valuer.name}</div>
                  <div style={{ color: '#6b7280', marginTop: 6 }}>Internal Ref: {valuer.valuerInternalRef || 'N/A'}</div>
                </div>
              </div>
              <div style={{ textAlign: 'right', minWidth: 180 }}>
                <div style={{ fontSize: 14, color: '#6b7280' }}>Created</div>
                {/* <div style={{ fontSize: 18, fontWeight: 700, color: '#059669' }}>{valuer.createdAt ? new Date(valuer.createdAt).toLocaleDateString() : 'N/A'}</div> */}
              </div>
            </div>
          </Card>

          <Card style={{ borderRadius: 12, border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <Descriptions
              title={<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><Icon.User size={18} style={{ color: '#1890ff' }} /><span style={{ fontWeight: 600 }}>Valuer Information</span></div>}
              bordered
              column={2}
              size="small"
              style={{ background: '#fff', borderRadius: 8 }}
            >
              <Descriptions.Item label="ID">{valuer.id}</Descriptions.Item>
              <Descriptions.Item label="Email">{valuer.email || (valuer.contactPerson.email || 'N/A')}</Descriptions.Item>
              <Descriptions.Item label="Phone">{valuer.phone || (valuer.contactPerson.phone || 'N/A')}</Descriptions.Item>
              <Descriptions.Item label="Internal Ref">{valuer.valuerInternalRef || 'N/A'}</Descriptions.Item>
              <Descriptions.Item label="Created By">{valuer.createdBy || 'N/A'}</Descriptions.Item>
              <Descriptions.Item label="Areas Covered" span={2}>{(valuer.areasCovered && valuer.areasCovered.length>0) ? valuer.areasCovered.join(', ') : 'Not specified'}</Descriptions.Item>
              <Descriptions.Item label="Addresses" span={2}>{valuer.addresses || 'N/A'}</Descriptions.Item>
              <Descriptions.Item label="Notes" span={2}>{valuer.notes || 'No additional notes'}</Descriptions.Item>
            </Descriptions>
          </Card>
        </>
      )}
    </div>
  );
}
